import { DocumentNode, OperationVariables, QueryHookOptions, gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { SavedAlertsByMedium } from '../types';

const AlertFields = `
  id
  status
  campaignType
  messageMedium
  metricName
  comparisonOperator
  threshold
  frequency
`;

const queryProjectCampaignAlerts = gql`
query getProjectCampaignAlerts($campaignType: CampaignTypeFilter, $messageMedium: MessageMedium, $status: ProjectCampaignAlertsStatus) {
  projectCampaignAlerts(campaignType: $campaignType, messageMedium: $messageMedium, status: $status) {
      Email {
        ${AlertFields}
      }
      Push {
        ${AlertFields}
      }
      SMS {
        ${AlertFields}
      }
      InApp {
        ${AlertFields}
      }
      WebPush {
        ${AlertFields}
      }
      Embedded {
        ${AlertFields}
      }
    }
  }
`;

export type UseProjectCampaignAlertsData = { projectCampaignAlerts: SavedAlertsByMedium };

export const useProjectCampaignAlertsQuery = (
  options?: QueryHookOptions<UseProjectCampaignAlertsData, OperationVariables>,
  query: DocumentNode = queryProjectCampaignAlerts,
) => {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
  } = useGraphql<UseProjectCampaignAlertsData, OperationVariables>(query, queryOptions);

  const results = data?.projectCampaignAlerts ?? ({} as SavedAlertsByMedium);

  return {
    errorMessage,
    hasError,
    isLoading,
    results,
  };
};
